<template>
	<div>
		<case-form :schema="schemaShared" class="mt6" />
		<case-form :schema="schemaAssets" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">Real Estate</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaPropertyList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6 mb2">Net Business Interests</div>
		<j-accordion
			v-for="j in 3"
			:key="j"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ j }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaNetBusinessList(j)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form class="mt6" :schema="schemaExtra" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaShared() {
			return [
				{
					label: `Is Balance sheet shared? (Assets)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsIsShared`,
					props: {
						suggest: {
							typeIncludes: `assetsIsShared`
						},
						createOptions: {
							type: `assetsIsShared`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>If "yes" answer the questions below</div>`
					},
					bindTo: ""
				},
				{
					label: `Shared with (Indiciate Relationship):`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsSharedWith`,
					props: {
						suggest: {
							typeIncludes: `assetsSharedWith`
						},
						createOptions: {
							type: `assetsSharedWith`,
							dataType: "string"
						}
					}
				},
				{
					label: `Portion earned by Client (%)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsSharedRatio`,
					props: {
						suggest: {
							typeIncludes: `assetsSharedRatio`
						},
						createOptions: {
							type: `assetsSharedRatio`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaAssets() {
			return [
				{
					label: `Cash and Savings (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsCashAndSavings`,
					props: {
						suggest: {
							typeIncludes: `assetsCashAndSavings`
						},
						createOptions: {
							type: `assetsCashAndSavings`,
							dataType: "number"
						}
					}
				},
				{
					label: `Stocks and Bonds (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsStocksAndBonds`,
					props: {
						suggest: {
							typeIncludes: `assetsStocksAndBonds`
						},
						createOptions: {
							type: `assetsStocksAndBonds`,
							dataType: "number"
						}
					}
				},
				{
					label: `Personal Property (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsPersonalProperty`,
					props: {
						suggest: {
							typeIncludes: `assetsPersonalProperty`
						},
						createOptions: {
							type: `assetsPersonalProperty`,
							dataType: "number"
						}
					}
				},
				{
					label: `Real Estate (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsRealEstate`,
					props: {
						suggest: {
							typeIncludes: `assetsRealEstate`
						},
						createOptions: {
							type: `assetsRealEstate`,
							dataType: "number"
						}
					}
				},
				{
					label: `Net Business Interest (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetsNetBusinessInterest`,
					props: {
						suggest: {
							typeIncludes: `assetsNetBusinessInterest`
						},
						createOptions: {
							type: `assetsNetBusinessInterest`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaExtra() {
			return [
				{
					label: `Other (please specify) (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessOther`,
					props: {
						suggest: {
							typeIncludes: `netBusinessOther`
						},
						createOptions: {
							type: `netBusinessOther`,
							dataType: "number"
						}
					}
				},
				{
					label: `Total Assets`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0assetTotal`,
					props: {
						suggest: {
							typeIncludes: `assetTotal`
						},
						createOptions: {
							type: `assetTotal`,
							dataType: "number"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPropertyList(i) {
			return [
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: `case.facts.insured0realEstateAddress${i}`,
					props: {
						suggest: {
							typeIncludes: `realEstateAddress${i}`
						},
						createOptions: {
							type: `realEstateAddress${i}`
						}
					}
				},
				{
					label: `Purpose:Personal`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateForPersonal${i}`,
					props: {
						suggest: {
							typeIncludes: `realEstateForPersonal${i}`
						},
						createOptions: {
							type: `realEstateForPersonal${i}`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Purpose:Business`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateForBusiness${i}`,
					props: {
						suggest: {
							typeIncludes: `realEstateForBusiness${i}`
						},
						createOptions: {
							type: `realEstateForBusiness${i}`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Purpose:Rental`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateForRental${i}`,
					props: {
						suggest: {
							typeIncludes: `realEstateForRental${i}`
						},
						createOptions: {
							type: `realEstateForRental${i}`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `Property Value (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0realEstateValue${i}`,
					props: {
						suggest: {
							typeIncludes: `realEstateValue${i}`
						},
						createOptions: {
							type: `realEstateValue${i}`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaNetBusinessList(j) {
			return [
				{
					label: `Company Name`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessCompanyName${j}`,
					props: {
						suggest: {
							typeIncludes: `netBusinessCompanyName${j}`
						},
						createOptions: {
							type: `netBusinessCompanyName${j}`,
							dataType: "string"
						}
					}
				},
				{
					label: `City and Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessCityAndCountry${j}`,
					props: {
						suggest: {
							typeIncludes: `netBusinessCityAndCountry${j}`
						},
						createOptions: {
							type: `netBusinessCityAndCountry${j}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Percentage Owned`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessPercentageOwned${j}`,
					props: {
						suggest: {
							typeIncludes: `netBusinessPercentageOwned${j}`
						},
						createOptions: {
							type: `netBusinessPercentageOwned${j}`,
							dataType: "number"
						}
					}
				},
				{
					label: `Website`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessWebsite${j}`,
					props: {
						suggest: {
							typeIncludes: `netBusinessWebsite${j}`
						},
						createOptions: {
							type: `netBusinessWebsite${j}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Business Value (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0netBusinessValue${j}`,
					props: {
						suggest: {
							typeIncludes: `netBusinessValue${j}`
						},
						createOptions: {
							type: `netBusinessValue${j}`,
							dataType: "number"
						}
					}
				}
			]
		}
	}
}
</script>
